module.exports = __webpack_public_path__ + "baike_bg.png?004a0fe279de3fa8540aa320dbdb314d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/baike_bg.png
// module id = 327
// module chunks = 1